import { type ApplicationErrorDto } from '../../services/admin.api';
import { icon } from '../../icons';
import { t } from '../../services/i18n';
import { esc, formatDate } from './admin-shared';

function renderOptionalValue(value: string | null): string {
  return value ? esc(value) : '&mdash;';
}

function renderPreformatted(value: string | null): string {
  return value ? `<pre class="admin-error-pre">${esc(value)}</pre>` : '<span class="admin-detail-value">&mdash;</span>';
}

export function openAdminApplicationErrorDetails(applicationError: ApplicationErrorDto): void {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';

  overlay.innerHTML = `
    <div class="modal admin-error-detail">
      <div class="modal-header">
        <div>
          <div class="admin-detail-meta">
            <span class="badge badge-admin-error">${esc(String(applicationError.statusCode))}</span>
            <span>${esc(applicationError.functionName)}</span>
          </div>
          <h2 class="admin-detail-email">${esc(applicationError.message)}</h2>
        </div>
        <button class="modal-close">${icon('x', { size: 18 })}</button>
      </div>
      <div class="admin-detail-grid">
        <div class="admin-detail-item">
          <span class="admin-detail-label">${t('admin.errors.col.occurredAt')}</span>
          <span class="admin-detail-value">${formatDate(applicationError.occurredAtUtc)}</span>
        </div>
        <div class="admin-detail-item">
          <span class="admin-detail-label">${t('admin.errors.col.method')}</span>
          <span class="admin-detail-value">${renderOptionalValue(applicationError.method)}</span>
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.path')}</span>
          <span class="admin-detail-value admin-detail-mono">${renderOptionalValue(applicationError.path)}</span>
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.exceptionType')}</span>
          <span class="admin-detail-value admin-detail-mono">${esc(applicationError.exceptionType)}</span>
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.userId')}</span>
          <span class="admin-detail-value admin-detail-mono">${renderOptionalValue(applicationError.userId)}</span>
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.invocationId')}</span>
          <span class="admin-detail-value admin-detail-mono">${renderOptionalValue(applicationError.invocationId)}</span>
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.stackTrace')}</span>
          ${renderPreformatted(applicationError.stackTrace)}
        </div>
        <div class="admin-detail-item admin-detail-item--full">
          <span class="admin-detail-label">${t('admin.errors.col.metadata')}</span>
          ${renderPreformatted(applicationError.metadataJson)}
        </div>
      </div>
    </div>
  `;

  const close = (): void => overlay.remove();
  overlay.querySelector('.modal-close')?.addEventListener('click', close);
  overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
  document.addEventListener('keydown', function onKey(event) {
    if (event.key === 'Escape') {
      close();
      document.removeEventListener('keydown', onKey);
    }
  });

  document.body.appendChild(overlay);
}
